import React from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import StarIcon from '@material-ui/icons/StarBorder';

import { Typography } from '@material-ui/core';

import useStyles from './styles';
import LoadingButton from '../LoadingButton';

import { IPlan } from '../../shared/interfaces/plan-interfaces';

type IProps = {
  tier: IPlan;
  handleClick: () => void;
  buttonText: string;
  buttonVariant?: 'outlined' | 'contained' | 'text' | undefined;
  buttonDisabled?: boolean;
  loading?: boolean;
};

const ItemTier: React.FC<IProps> = props => {
  const classes = useStyles();

  const {
    tier,
    handleClick,
    buttonText,
    buttonVariant = 'contained',
    buttonDisabled = false,
    loading = false,
  } = props;

  return (
    <Card>
      <CardHeader
        title={tier.name}
        titleTextProps={{ align: 'center' }}
        subheaderTextProps={{ align: 'center' }}
        action={tier.name === 'Gold' ? <StarIcon /> : null}
        className={classes.cardHeader}
      />
      <CardContent>
        <div className={classes.cardPricing}>
          <Typography component="h2" variant="h3" color="textPrimary">
            {`R$ ${tier.value}`}
          </Typography>
          <Typography variant="h6" color="textSecondary">
            /mês
          </Typography>
        </div>
        <p>{tier.description}</p>
        <Typography>
          <strong>Quant. de usuários: </strong>
          {tier.max_users}
        </Typography>
      </CardContent>
      <CardActions>
        <LoadingButton
          fullWidth
          disabled={buttonDisabled}
          variant={buttonVariant}
          color="primary"
          onClick={handleClick}
          loading={loading}
        >
          {buttonText}
        </LoadingButton>
      </CardActions>
    </Card>
  );
};

ItemTier.defaultProps = {
  buttonDisabled: false,
  loading: false,
};

export default ItemTier;
